import pxToEm from "./helpers/pxtoem";

const moveUpElements = () => {

	
    // const content = document.querySelector(".content-wrapper");
    const moveup = document.querySelectorAll(".has-moveup-attribute");

	// function hasContentWrapperParent(element) {
	// 	if (element.previousSibling && element.previousSibling.parentNode) {
			
	// 		console.log(element);
	// 		if (
	// 			element.previousSibling.parentNode.classList.contains(
	// 				"content-wrapper"
	// 			)
	// 		) {
	// 			return element.previousSibling;
	// 		} else {
	// 			return hasContentWrapperParent(element.previousSibling.parentNode);
	// 		}
	// 	} 
	// 	return false;
	// }

	//em = px / font-size (default is 16px).

	moveup.forEach(function (item) {
		const translateNumber = parseInt(item.getAttribute("data-moveup"));
		const translateNumberRem = pxToEm(translateNumber);
		const elementMarginBottom = parseFloat(
			getComputedStyle(item).marginBottom
		);

		item.style.transform = `translateY(-${translateNumberRem}rem)`;
		item.style.marginBottom =
			-translateNumberRem + pxToEm(elementMarginBottom) + "rem";

		const sibling = item.previousElementSibling;
		

		if (sibling) {
		
			item.previousElementSibling.classList.add("moveup-previous");

			const previousPadding = parseFloat(
				getComputedStyle(item.previousElementSibling).paddingBottom
			);

			if (previousPadding != 0){
				item.previousElementSibling.style.paddingBottom =
					pxToEm(previousPadding) + translateNumberRem + "rem";
			}else{
				item.previousElementSibling.style.paddingBottom = translateNumberRem + "rem";
			}
				
		}
	});

	// if (content) {
	// 	const firstElement = content.firstElementChild;
	// 	if (firstElement.classList.contains("hero") === true) {
	// 		document
	// 			.querySelector(".site-header")
	// 			.classList.add("color-light");
	// 	}

	// 	if (firstElement.classList.contains("hero-overlay-active") === true) {
	// 		document
	// 			.querySelector(".site-header")
	// 			.classList.add("color-light-logo");
	// 	}
	// }
}

export { moveUpElements };
